<template>
  <v-container fluid>
    <v-row>
      <h1>Signed out</h1>
    </v-row>
    <v-row>
      <button @click="signIn">click here to sign in</button>
    </v-row>
  </v-container>
</template>

<script>
import router from "../router";
import { msalMixin } from 'vue-msal'; 
export default {
  name: "SignIn",
  mixins: [msalMixin],
  watch: {
    msal: {
      handler(val) {
        if (val.isAuthenticated) {
          router.push({ name: "Home" });
        }
      },
      deep: true
    }
  },
  methods: {
    signIn() {
      sessionStorage.clear();
      window.location.reload(true);
    }
  }
};
</script>